import type { IConfigurationRepository, UpsertConfigurationInput } from '../repositories/IConfigurationRepository.js';

export function createUpsertConfigurationUseCase({ configurationRepository }: { configurationRepository: IConfigurationRepository }) {
  return (input: UpsertConfigurationInput) => configurationRepository.upsert(input);
}
